import React, { useContext, useEffect, useState } from "react";
import {AppState} from "../lib/context/AppProvider";
import Header from "../components/Header";
import { useLocation, useNavigate } from "react-router-dom";

function JoinGroup() {
    const {user } = useContext(AppState);

    const navigate = useNavigate();
    const location = useLocation();

    const [error, setError] = useState(null);
    
    const groupId = location.pathname.split("/join/")[1];

    useEffect(() => {

        if(user.isGuest) {
            setError("You must be logged into an account to join a group.");
            return;
        }

        if(groupId) {
            navigate(`/settings#groups/${groupId}`);
        }
        
    }, [user, groupId, navigate]);
    
    return (  
        <>
            <Header
                showSideBarMenu={true}
                showDashboardMenu={false}
                height={56} 
                className="pb-5"
            />
            <div className="page-background">
                <section className="settings-section">
                    <h4 className="settings-section-title">Join Group</h4>
                    <hr style={{ borderColor: '#495057' }}/>

                    {error && (<p style={{color: "red"}}>{error}</p>)}
                    {!error && (
                        groupId ? <p>Finding group...</p> : <p style={{color: "red"}}>Unknown group!</p>
                    )}
                </section>
            </div>
        </>
    );
}

export default JoinGroup;
